document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('evidence-sources-container');
    const addButton = document.querySelector('.add-source-btn');

    if (addButton && container) {
        addButton.addEventListener('click', function() {
            // Create new input group
            const newSourceGroup = document.createElement('div');
            newSourceGroup.className = 'evidence-source-input';

            // Create input field
            const input = document.createElement('input');
            input.type = 'text';
            input.name = 'evidence_sources[]';
            input.placeholder = 'e.g., www.cnn.com or https://www.cnn.com';
            input.required = true;

            // Create remove button
            const removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'remove-source-btn';
            removeBtn.innerHTML = '<i class="fas fa-minus"></i> Remove';
            removeBtn.onclick = function() {
                newSourceGroup.remove();
            };

            // Add elements to the group
            newSourceGroup.appendChild(input);
            newSourceGroup.appendChild(removeBtn);

            // Insert before the container's last child (the add button group)
            container.appendChild(newSourceGroup);
        });
    }
}); 